import { object, unknown, number, minValue, integer, parse } from 'valibot';

const cacheItemSchema = object({
    value: unknown(),
    expiry: number([
        minValue(0),
        integer(),
    ]),
});

const setCache = ({ key, value, ttl, }) => {
    window.localStorage.setItem(key, JSON.stringify({
        value,
        expiry: Date.now() + ttl * 1000,
    }));
};
const getCache = (key) => {
    const storageItem = window.localStorage.getItem(key);
    try {
        const { expiry, value, } = parse(cacheItemSchema, storageItem && JSON.parse(storageItem));
        return Date.now() > expiry
            ? undefined
            : value;
    }
    catch (e) {
        return undefined;
    }
};

export { cacheItemSchema, getCache, setCache };
//# sourceMappingURL=index.js.map
